/* global google */
import React, { Component } from "react";
import { Button, Icon, Tooltip, notification, Typography, Input } from "antd";
import {
  withGoogleMap,
  GoogleMap,
  Marker,
  withScriptjs,
} from "react-google-maps";
import { compose, withProps } from "recompose";
import InfoBox from "react-google-maps/lib/components/addons/InfoBox";
import InfoWindow from "react-google-maps/lib/components/InfoWindow";
import { convertBounds, getBoundsSideKm } from "../services/display";

import markerPin from "../images/markerPin.png";

import { withTranslation } from "react-i18next";
import {getFilterDisplaysForContains} from "../services/display";

import DisplayMarker from "./features/map_view/components/DisplayMarker";
import ClusterMarker from "./features/map_view/components/ClusterMarker";
import DrawControlButton from "./features/map_view/components/DrawControlButton";
import VenueCategoryLegend from "./features/map_view/components/VenueCategoryLegend";
import MAP_STYLES, { HIDE_POI_LABELS } from "./features/map_view/mapStyles";

import { debounce } from "lodash";

import { withThemeMapStyles } from '../themes/mapTheme';
import { isDarkTheme } from '../themes/theme';
const IsPointIn = require("@pelevesque/is-point-in");

const Search = Input.Search;

const { Paragraph } = Typography;

// Backend "detail" mode is drawn as plain category dots while the longest
// viewport side is above this, and as icon markers once zoomed in closer.
const POINT_MODE_MIN_KM = 5;

export const ResultsMap = withTranslation()(
  compose(
    withProps({
      googleMapURL:
        `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_KEY}&v=3.exp&libraries=geometry,drawing,places`,
    }),
    withScriptjs,
    withGoogleMap
  )(
    class ResultsMapComponent extends Component {
      constructor(props) {
        super(props);

        this.state = {
          isMapFit: false,
          displaysAudience: [],
          screenDetail: false,
          displaysAction: null,
          searchResult: [],
          showingInfoWindow: false,
          activeMarker: {},
          selectedPlace: {},
          overlays: [],
        };

        this.debouncedUpdateMapBounds = debounce(this.updateMapBounds, 500);
      }

      getSizeType(type) {
        if (type === "small") {
          return this.props.t("Small");
        }
        if (type === "medium") {
          return this.props.t("Medium");
        }
        if (type === "big") {
          return this.props.t("Big");
        }
        if (type === "giant") {
          return this.props.t("Giant");
        }
      }

      componentDidMount() {
        if (this.map && !this.state.isMapFit) {
          // Set street view controls position
          this.map.getStreetView().setOptions({
            addressControlOptions: {
              position: google.maps.ControlPosition.BOTTOM_CENTER,
            },
          });

          this.map.panToBounds(this.props.bounds);
          this.setState({ isMapFit: true });

          if (this.props.cart && this.props.cart.length === 0) {
            this.openZoomAlert("bottomRight");
          }
        }
      }

      componentDidUpdate(prevProps) {
        const {searchPlace}= this.props;
        const { east, south } = this.props.bounds;
        if (this.map && !this.state.isMapFit) {
          this.map.panToBounds(this.props.bounds);
          this.setState({ isMapFit: true });
        }
        if (this.map && this.props.relocateMap) {
          this.map.panToBounds(this.props.bounds);
          this.props.mapRelocated();
        }
        if (this.map && this.props.searchLocation) {
          this.props.setBounds(convertBounds(this.map.getBounds()));
          // this.props.setBounds(this.props.bounds);
          this.props.searchLocationOff();
        }
        if (!(searchPlace === "" && prevProps.searchPlace === "") && ( prevProps.searchPlace !== searchPlace || east !== prevProps.bounds.east || south !== prevProps.bounds.south)) {
          this.onPlaceSearch(searchPlace);
        }
      }

      handlePlace = (place) => {
        this.setState({ place });
      };

      openZoomAlert = (placement) => {
        notification.info({
          message: this.props.t(
            "Remember to zoom out the map to see more results"
          ),
          description: this.props.t(
            "Only screens that are within the visible area of the map will be displayed."
          ),
          duration: 7,
          placement,
        });
      };

      screenDetail = () => {
        this.setState({
          screenDetail: true,
        });
      };
      okScreenDetail = (e) => {
        this.setState({
          screenDetail: false,
        });
      };
      cancelScreenDetail = (e) => {
        this.setState({
          screenDetail: false,
        });
      };

      callback = (results, status) => {
        if (status == google.maps.places.PlacesServiceStatus.OK) {
          this.setState({
            searchResult: results,
          });
        }
      };

      onPlaceSearch = (searchPlace) => {
        if(searchPlace === "") {
          this.setState({
            searchResult: [],
          });
        }
        const { east, north, south, west } = this.props.bounds;
        var map;
        var service;
        // Calculate center of coordinates
        var centerLat = (north + south) / 2;
        var centerLng = (west + east) / 2;
        var pyrmont = new google.maps.LatLng(centerLat, centerLng);

        map = new google.maps.Map(document.createElement('div'), {
          center: pyrmont,
          zoom: 15,
        });

        var request = {
          location: pyrmont,
          radius: "500",
          query: searchPlace,
        };

        service = new google.maps.places.PlacesService(map);
        service.textSearch(request, this.callback);
      };

      checkPoint = (long, lat, cX, cY, radius) => {
        IsPointIn.circle(long, lat, cX, cY, radius);
      };

      onMarkerClick = (props, marker, e) => {
        this.setState({
          selectedPlace: props,
          activeMarker: marker,
          showingInfoWindow: true,
        });
      };

      onInfoWindowClose = () => {
        this.setState({
          activeMarker: null,
          showingInfoWindow: false,
        });
      };

      displayMarkers = () => {
        const { searchResult } = this.state;
        if (searchResult.length > 0) {
          return searchResult.map((marker, i) => {
            return (
              <Marker
                key={i}
                position={marker.geometry.location}
                clickable={true}
                onClick={() => this.onMarkerClick(marker)}
                cursor="pointer"
                icon={{
                  url: markerPin,
                  size: { width: 30, height: 37 },
                  scaledSize: { width: 30, height: 37 },
                }}
              />
            );
          });
        }
      };

      // Función unificada para actualizar los bounds
      updateMapBounds = async () => {
        if (!this.map) {
          return;
        }
        const bounds = await this.map.getBounds();
        this.props.setBounds(convertBounds(bounds));
        this.props.setMapZoom(this.map.getZoom());
      }

      handleDragEnd = () => {
        this.debouncedUpdateMapBounds();
      }

      handleZoomChanged = () => {
        this.debouncedUpdateMapBounds();
      }

      componentWillUnmount() {
        // Cancelar el debounce pendiente
        if (this.debouncedUpdateMapBounds) {
          this.debouncedUpdateMapBounds.cancel();
        }
      }

      // Show card when is selected
      checkDisplaySelected = (currentDisplay, display) => {
        if (!currentDisplay) return false;
        // If the current display is secondary
        if (display.is_secondary) {
          return currentDisplay.id_secondary_display === display.id_secondary_display;
        }
        // If is the main display
        return currentDisplay.id === display.id;
      }

      // Flattens main + secondary displays into a single marker list, cached
      // by displaysMap reference so we don't reallocate dozens of clone
      // objects on every render (e.g. on hover).
      _expandedCache = { input: null, output: null };
      getExpandedDisplays = (displaysMap) => {
        if (this._expandedCache.input === displaysMap) {
          return this._expandedCache.output;
        }
        const result = [];
        (displaysMap || []).forEach((initDisplay) => {
          if (initDisplay.is_main_display) {
            result.push(initDisplay);
            if (Array.isArray(initDisplay.secondary_displays)) {
              initDisplay.secondary_displays.forEach((secondaryDisplay) => {
                const aux = Object.assign({}, initDisplay);
                aux.latitude = secondaryDisplay.latitude;
                aux.longitude = secondaryDisplay.longitude;
                aux.name_secondary_display = secondaryDisplay.name;
                aux.id_secondary_display = secondaryDisplay.id;
                aux.is_secondary = true;
                result.push(aux);
              });
            }
          } else {
            result.push(initDisplay);
          }
        });
        this._expandedCache = { input: displaysMap, output: result };
        return result;
      };

      handleClusterClick = (cluster) => {
        if (!this.map) return;
        const lat = parseFloat(cluster.cluster_lat);
        const lng = parseFloat(cluster.cluster_lng);
        if (isNaN(lat) || isNaN(lng)) return;
        this.map.panTo({ lat, lng });
        const currentZoom = this.map.getZoom();
        this.props.setMapZoom(Math.min((currentZoom || 12) + 3, 18));

        if (this.debouncedUpdateMapBounds) {
          this.debouncedUpdateMapBounds.cancel();
        }
        setTimeout(async () => {
          await this.updateMapBounds();
          this.props.refreshDisplays();
        }, 500);
      }

      renderClusterMarkers = () => {
        const { displaysMap } = this.props;
        return (displaysMap || []).map((cluster, index) => {
          const lat = parseFloat(cluster.cluster_lat);
          const lng = parseFloat(cluster.cluster_lng);
          if (isNaN(lat) || isNaN(lng)) return null;
          const count = cluster.count || (cluster.ids ? cluster.ids.length : 0);
          return (
            <ClusterMarker
              key={`cluster-${lat}-${lng}-${index}`}
              cluster={cluster}
              lat={lat}
              lng={lng}
              count={count}
              onClick={this.handleClusterClick}
            />
          );
        });
      }

      render() {
        const { t, hoverDisplay, currentDisplay, displaysMapMode } = this.props;
        const { selectedPlace, showingInfoWindow } = this.state;
        const isClusterMode = displaysMapMode === "cluster";
        // cluster -> point -> detail as the user zooms in.
        const renderMode = isClusterMode
          ? "cluster"
          : getBoundsSideKm(this.props.bounds) > POINT_MODE_MIN_KM
            ? "point"
            : "detail";
        return (
          <GoogleMap
            ref={(map) => (this.map = map)}
            defaultZoom={this.props.mapZoom}
            zoom={this.props.mapZoom}
            options={{
              clickableIcons: false, // not interactue with icons
              fullscreenControl: false,
              mapTypeControl: false,
              restriction: {
                latLngBounds: {
                  north: 85,
                  south: -85,
                  west: -180,
                  east: 180,
                },
                strictBounds: true,
              },
              // Pastel palette in light mode; Google's night style in dark mode.
              styles: isDarkTheme() ? withThemeMapStyles([HIDE_POI_LABELS]) : MAP_STYLES,
              streetViewControlOptions: {
                position: google.maps.ControlPosition.LEFT_BOTTOM,
              },
              zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_BOTTOM,
              },
            }}
            // center={this.props.defaultCenter}
            defaultCenter={this.props.defaultCenter}
            loadingElement={this.props.loadingElement}
            containerElement={this.props.containerElement}
            mapElement={this.props.mapElement}
            // onDragEnd={async () => {
            //   if (!this.map) {
            //     return;
            //   }
            //   const bounds = await this.map.getBounds();
            //   this.props.setBounds(convertBounds(bounds));
            //   // this.props.updateCenter(
            //   //   (coord.bounds.lat_sw + coord.bounds.lat_ne) / 2,
            //   //   (coord.bounds.lng_sw + coord.bounds.lng_ne) / 2
            //   // );
            //   // this.props.changeDragInMap(false);
            //   // this.props.refreshDisplays();
            // }}
            // onZoomChanged={async () => {
            //   if (!this.map) {
            //     return;
            //   }
            //   const bounds = await this.map.getBounds();
            //   this.props.setBounds(convertBounds(bounds));
            //   this.props.setMapZoom(this.map.getZoom());
            //   // this.props.refreshDisplays();
            // }}
            onDragEnd={this.handleDragEnd}
            onZoomChanged={this.handleZoomChanged}
          >
            {/* <TrafficLayer autoUpdate /> */}
            <DrawControlButton
              map={this.map}
              displaysMap={this.props.displaysMap}
              cart={this.props.cart}
              isClusterMode={isClusterMode}
              addDisplaysFromPolygon={this.props.addDisplaysFromPolygon}
              addClusterDisplaysFromPolygon={this.props.addClusterDisplaysFromPolygon}
              updateArrayPolygon={this.props.updateArrayPolygon}
              removeDisplaysFromPolygon={this.props.removeDisplaysFromPolygon}
              shouldClearPolygons={this.props.shouldClearPolygons}
              onPolygonsCleared={this.props.onPolygonsCleared}
              loading={this.props.clusterPolygonLoading}
            />
            {!isClusterMode && <VenueCategoryLegend map={this.map} />}
            {isClusterMode
              ? this.renderClusterMarkers()
              : this.getExpandedDisplays(this.props.displaysMap).map(
                  (display, index) => {
                    if (!getFilterDisplaysForContains(display, this.props.user)) {
                      return null;
                    }
                    const isOnCart = this.props.cart.find(
                      (d) => d.id === display.id,
                    );
                    // Compare by id instead of object ref — hoverDisplay
                    // comes from /displays/results while markers come from
                    // /displays/map, so refs never match across the two.
                    const isHovered =
                      !!(hoverDisplay && hoverDisplay.id === display.id);
                    const isSelected = this.checkDisplaySelected(
                      currentDisplay,
                      display,
                    );
                    const markerKey = display.is_secondary
                      ? `${display.id}-sec-${display.id_secondary_display}`
                      : `${display.id}-${index}`;
                    return (
                      <DisplayMarker
                        key={markerKey}
                        display={display}
                        variant={renderMode}
                        isHovered={isHovered}
                        isSelected={isSelected}
                        isOnCart={isOnCart}
                        openDisplay={this.props.openDisplay}
                        handleClose={this.props.closeDisplay}
                        paymentStatus={this.props.editCampaign.payment_status}
                        addDisplayToCart={this.props.addDisplayToCart}
                        removeDisplayFromCart={this.props.removeDisplayFromCart}
                        getAudience={this.props.getAudience}
                        cart={this.props.cart}
                        programmatic={this.props.programmatic}
                        date_from={this.props.date_from}
                        date_to={this.props.date_to}
                        editCampaignActive={this.props.editCampaignActive}
                        listBundle={this.props.listBundle}
                        initialBackup={this.props.initialBackup}
                        hasInitialBackup={this.props.hasInitialBackup}
                      />
                    );
                  },
                )}
            {this.displayMarkers()}
            {showingInfoWindow && (
              <InfoWindow
                position={selectedPlace.geometry.location}
                visible={showingInfoWindow}
                onCloseClick={this.onInfoWindowClose}
                options={{ pixelOffset: new window.google.maps.Size(0, -30) }}
              >
                <h5>{selectedPlace.name}</h5>
              </InfoWindow>
            )}
          </GoogleMap>
        );
      }
    }
  )
);
